import React, { FC } from 'react'
import {
  BusinessIdeaUserEvaluation,
  BusinessIdeaUserEvaluationType,
} from '../../enums/BusinessIdeaUserEvaluation'
import { GoodIcon } from '../../images/good_icon'
import { BadIcon } from '../../images/bad_icon'

type EvaluationButtonProps = {
  currentEvaluation: BusinessIdeaUserEvaluationType | null
  onEvaluate: (evaluation: BusinessIdeaUserEvaluationType) => void
  disabled?: boolean
}

const EvaluationButton: FC<EvaluationButtonProps> = ({
  currentEvaluation,
  onEvaluate,
  disabled = false,
}) => {
  const handleClick = (evaluation: BusinessIdeaUserEvaluationType) => {
    if (disabled || currentEvaluation === evaluation) {
      return
    }
    onEvaluate(evaluation)
  }

  return (
    <div className="flex gap-2">
      {/* Good Button */}
      <button
        onClick={(e) => {
          e.stopPropagation()
          handleClick(BusinessIdeaUserEvaluation.GOOD)
        }}
        disabled={disabled}
        type="button"
        className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <GoodIcon
          isActive={currentEvaluation === BusinessIdeaUserEvaluation.GOOD}
        />
      </button>

      {/* Bad Button */}
      <button
        onClick={(e) => {
          e.stopPropagation()
          handleClick(BusinessIdeaUserEvaluation.BAD)
        }}
        disabled={disabled}
        type="button"
        className={`${disabled ? 'opacity-50 cursor-not-allowed' : ''}`}
      >
        <BadIcon
          isActive={currentEvaluation === BusinessIdeaUserEvaluation.BAD}
        />
      </button>
    </div>
  )
}

export default EvaluationButton
